import { render, staticRenderFns } from "./tronscanMasterAccount.vue?vue&type=template&id=95f76bc4&scoped=true"
import script from "./tronscanMasterAccount.vue?vue&type=script&lang=js"
export * from "./tronscanMasterAccount.vue?vue&type=script&lang=js"
import style0 from "./tronscanMasterAccount.vue?vue&type=style&index=0&id=95f76bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f76bc4",
  null
  
)

export default component.exports